import { render, staticRenderFns } from "./GroupSetting.vue?vue&type=template&id=147764e6&scoped=true"
import script from "./GroupSetting.vue?vue&type=script&lang=ts"
export * from "./GroupSetting.vue?vue&type=script&lang=ts"
import style0 from "./GroupSetting.vue?vue&type=style&index=0&id=147764e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147764e6",
  null
  
)

export default component.exports